export const environment = {
    production: true,
    reportUrl: "/docflowserv/rs/",
    apiUrl : "/docflowserv/rs/"
};
